import { mercadonaDomain, OLD_SHOP_LANGUAGES } from '../constants'
import i18next from 'i18next'

const SELECTOR = '.o-menu'

let node

const Menu = {
  mount(currentLanguage) {
    node = document.querySelector(SELECTOR)
    this.render(currentLanguage, node)
  },

  render(currentLanguage) {
    currentLanguage = OLD_SHOP_LANGUAGES[currentLanguage]
    node.innerHTML = `
    <li class="o-menu__item">
      <a href="${mercadonaDomain}${currentLanguage}/inicio">
        ${i18next.t('header_section.option1')}
      </a>
    </li>
    <li class="o-menu__item">
      <a href="${mercadonaDomain}${currentLanguage}/supermercados">
        ${i18next.t('header_section.option2')}
      </a>
    </li>
    <li class="o-menu__item">
      <a href="https://mercadona.avature.net/es_ES/Careers">
        ${i18next.t('header_section.option3')}
      </a>
    </li>
    <li class="o-menu__item">
      <a href="${mercadonaDomain}${currentLanguage}/atencion-al-cliente">
        ${i18next.t('header_section.option4')}
      </a>
    </li>
  `
  },
}

export { Menu }
